import { render, staticRenderFns } from "./MyClientsIndex.vue?vue&type=template&id=e550a3f6&"
import script from "./MyClientsIndex.vue?vue&type=script&lang=js&"
export * from "./MyClientsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports